<template>
  <main class="about">
    <Breadcrumb></Breadcrumb>

    <section class="">
      <PageHeader
        title="Changing Lives Through Discovery and Innovation"
        :video="require(`@/assets/video/research.mp4`)"
        :backgroundImage="require(`@/assets/img/research-poster.jpg`)"
        backgroundColor="transparent"
        textColor="white"
        overlay="medium"
        align="center"
        size="lg"
      >
        <p>
          UGA faculty are recognized as leaders in their fields and members of
          prominent organizations including the National Academy of Sciences and
          the National Academy of Engineering, and the American Association for
          the Advancement of Science.
        </p>
      </PageHeader>
    </section>

    <Section type="full" imgSide="right" imgURL="research/36645-134.jpg">
      <h3>A Comprehensive Research Institution</h3>
      <p>
        As one of the nation’s top universities for technology
        commercialization, we work tirelessly to see our research discoveries
        benefit society. From combating infectious disease and creating a
        dependable food supply to strengthening cyber and global security, the
        University of Georgia is tackling the world’s greatest challenges in
        pursuit of a better tomorrow.
      </p>
      <p>
        Through research and innovation, we are improving the world through
        commitments to:
      </p>
      <ul class="row row-cols-1 row-cols-md-3 g-3 list-unstyled">
        <li class="col">
          <div class="card text-center bg-white border-light border-5 h-100">
            <div
              class="card-body d-flex flex-column justify-content-center align-items-center"
            >
              <span class="fs-4">Stronger Communities</span>
            </div>
          </div>
        </li>
        <li class="col">
          <div class="card text-center bg-white border-light border-5 h-100">
            <div
              class="card-body d-flex flex-column justify-content-center align-items-center"
            >
              <span class="fs-4">Healthier Lifestyles</span>
            </div>
          </div>
        </li>
        <li class="col">
          <div class="card text-center bg-white border-light border-5 h-100">
            <div
              class="card-body d-flex flex-column justify-content-center align-items-center"
            >
              <span class="fs-4">A More Secure Future</span>
            </div>
          </div>
        </li>
      </ul>
    </Section>

    <section class="row g-0">
      <div class="col-md-4">
        <Figure
          prefix=""
          :endAmount="65"
          :startAmount="0"
          :decimals="0"
          suffix="%"
          subheading="increase in NIH/NSF expenditures over 6 years"
          backgroundColor="red"
          textColor="white"
          :textured="false"
        ></Figure>
      </div>
      <div class="col-md-4">
        <Figure
          prefix="Top "
          :endAmount="5"
          :startAmount="0"
          subheading="for new products based on research for nearly a decade"
          backgroundColor="light"
          textColor="black"
          :textured="false"
        ></Figure>
      </div>
      <div class="col-md-4">
        <Figure
          prefix="$"
          :endAmount="545"
          :startAmount="0"
          suffix="M"
          subheading="R&amp;D Expenditures"
          backgroundColor="black"
          textColor="white"
          :textured="false"
        ></Figure>
      </div>
    </section>

    <section>
      <div class="row g-0">
        <div class="col-12 col-md-6" style="min-height: 400px;">
          <VideoBackground
            :src="require('@/assets/video/researchers.mp4')"
            :poster="require('@/assets/img/research/marshall-shepherd.jpg')"
          />
        </div>
        <div class="col-12 col-md-6">
          <div class="d-flex flex-column justify-content-center h-100 p-5">
            <h3>Nationally Recognized Faculty</h3>
            <p>
              Because of their commitment to advancing our world through
              science, UGA faculty become leaders in their fields. Many have
              earned membership into prominent organizations, including the
              American Association for the Advancement of Science, the National
              Academy of Engineering, and the National Academy of Sciences.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="bg-geo bg-geo--dark row g-0">
      <div class="col-md-4">
        <Figure
          prefix=""
          :endAmount="8"
          :startAmount="0"
          subheading="active members of National Academies"
          backgroundColor=""
          textColor="dark"
          :textured="false"
        ></Figure>
      </div>
      <div class="col-md-4">
        <Figure
          :endAmount="48"
          :startAmount="0"
          subheading="NSF Career Award winners"
          backgroundColor=""
          textColor="dark"
          :textured="false"
        ></Figure>
      </div>
      <div class="col-md-4">
        <Figure
          :endAmount="113"
          :startAmount="0"
          subheading="American Association for the Advancement of Science (AAAS) Fellows"
          backgroundColor=""
          textColor="dark"
          :textured="false"
        ></Figure>
      </div>
    </section>

    <Section
      type="standard"
      imgSide="right"
      imgURL="research/38754-049.jpg"
      color="bg-primary bg-diagonal--dark"
      class="text-white"
    >
      <h3>Innovation District</h3>
      <p>
        The
        <a class="text-white" href="https://innovation.uga.edu"
          >Innovation District</a
        >
        merges the strengths of bright minds from different disciplines to move
        research ideas into the marketplace.
      </p>
      <p>
        Our vision is to become a leading driver of economic development and
        community impact through innovation, entrepreneurship, and experiential
        learning.
      </p>
      <Btn color="white" size="lg" outline href="https://innovation.uga.edu/"
        >Learn More<span class="visually-hidden">
          about the Innovation District</span
        ></Btn
      >
    </Section>
  </main>
</template>

<script>
// @ is an alias to /src
// import EmergencyBanner from '@/components/EmergencyBanner.vue';
import Btn from "@/components/Btn.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import PageHeader from "@/components/PageHeader.vue";
import Figure from "@/components/Figure.vue";
import Section from "@/components/Section.vue";
import VideoBackground from "@/components/VideoBackground.vue";

export default {
  name: "Research",
  metaInfo: {
    title: "Research at UGA",
    description:
      "The University of Georgia is committed to changing lives through discovery and innovation. Our comprehensive research is saving lives.",
    og: {
      image: "",
      title: "",
      description: "",
    },
  },
  methods: {},
  data() {
    return {};
  },
  components: {
    // EmergencyBanner,
    Btn,
    PageHeader,
    Breadcrumb,
    Figure,
    Section,
    VideoBackground,
  },
};
</script>

<style scoped lang="scss"></style>
